import { render } from "./Create.vue?vue&type=template&id=348e5b56&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=348e5b56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348e5b56"]])

export default __exports__